import { ReportStatusTypes } from '../../models/ReportStatus.model'
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export class ReviewService {
  /**
   * Report a review by id
   */
  public async reportReview(reviewId: number, report: ReportStatusTypes): Promise<void> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    await scrubstrApiQueryService.post({
      endpoint: `report-review/${reviewId}`,
      data: { isReported: report },
    })
  }
}
